import React, { useState } from 'react';
import TableauGroupeEmail from './TableauGroupeEmail/TableauGroupeEmail';
import FormulaireGroupeEmail from './ProfilGroupeEmail/FormulaireGroupeEmail/FormulaireGroupeEmail';
import ProfilGroupeEmail from './ProfilGroupeEmail/ProfilGroupeEmail';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as indexConteneurInfo from '../../../ressources/glossaires/glossaire_conteneur_info';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import styles from './GroupeEmail.module.scss';
import { RiAddCircleLine } from 'react-icons/ri';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';

const GroupeEmail = ({ reqAjouter, reqModifier, reqSupprimer }) => {
  const [infoSelect, setInfoSelect] = useState(null);
  const [indexConteneurInfoState, setIndexConteneurInfo] = useState(0);

  const selectioneLigne = (ligne) => {
    setInfoSelect(ligne);
    setIndexConteneurInfo(indexConteneurInfo.profil);
  };

  const creerGroupeEmail = () => {
    setIndexConteneurInfo(indexConteneurInfo.ajouterForm);
  };

  const handleAnnuler = () => {
    setInfoSelect(null);
    setIndexConteneurInfo(0);
  };

  let affichageFormulaireGroupeEmail;
  switch (indexConteneurInfoState) {
    case indexConteneurInfo.ajouterForm:
      affichageFormulaireGroupeEmail = (
        <span style={{ display: 'block' }}>
          <FormulaireGroupeEmail
            reqAjouter={reqAjouter}
            annuler={handleAnnuler}
          />
        </span>
      );
      break;
    case indexConteneurInfo.profil:
      affichageFormulaireGroupeEmail = (
        <ProfilGroupeEmail
          infoSelect={infoSelect}
          reqModifier={reqModifier}
          reqSupprimer={reqSupprimer}
        />
      );
      break;
    default:
      affichageFormulaireGroupeEmail = (
        <div className={styles.fontSize}>
          {checkMot('selectionne_un_groupe_de_mail')}
        </div>
      );
  }

  return (
    <div className={[s.row, styles.comtnet].join(' ')}>
      <div className={s.col_sm_6}>
        <div className={styles.fontSize}>
          {checkMot('liste_des_groupes_des_emails')}
        </div>
        <AccesRestreins
          listNumPrivilege={[
            privilege.creer_des_groupes_emails,
            privilege.modifier_des_groupes_emails,
            privilege.supprimer_des_groupes_emails,
          ]}
        >
          <TableauGroupeEmail selectioneLigne={selectioneLigne} />
        </AccesRestreins>
        <AccesRestreins numPrivilege={privilege.creer_des_groupes_emails}>
          <button onClick={creerGroupeEmail} className={styles.btadd}>
            <RiAddCircleLine size={34} />
            {checkMot('creer_un_groupe_email')}
          </button>
        </AccesRestreins>
      </div>
      <div className={s.col_sm_6}>{affichageFormulaireGroupeEmail}</div>
    </div>
  );
};

export default GroupeEmail;
